import React from 'react';
import styled, {keyframes} from 'styled-components';
import {font} from '../utils/styledComponentsMixins';

export const AnimateLoader = () => {
    return (
        <LoadingContainer>
            <Text>Загрузка</Text>
            <Dot delay="0s">.</Dot>
            <Dot delay="0.2s">.</Dot>
            <Dot delay="0.4s">.</Dot>
        </LoadingContainer>
    );
};

const blink = keyframes`
  0% {
    opacity: 0.2;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 0.2;
    transform: scale(1);
  }
`;

const LoadingContainer = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  ${font.text(400)}
`;

const Text = styled.span`
  margin-right: 5px;
`;

const Dot = styled.span.withConfig({
    shouldForwardProp: prop => !['delay'].includes(prop)
})<{ delay: string }>`
  animation: ${blink} 1.4s infinite;
  animation-delay: ${({delay}) => delay || '0s'};
  display: inline-block;
  font-size: 14px;
`;
